export enum AppRoutePath { // ToDo: All routes should be here
  CAMPAIGNS = 'campaigns',
  CAMPAIGNS_LINE_ITEMS = 'line-items',
  CAMPAIGNS_CREATIVE_LIBRARY = 'creative-library',
  CAMPAIGNS_MODERATION_QUEUE = 'moderation-queue',
  CREATIVE_DESIGNER ='creative-designer',
  BLOCK_LIST = 'block-list',
  TARGETING = 'targeting',
  TARGETING_NEW = 'new',
  TARGETING_EDIT = 'edit',
  ERRORS = 'errors',
}
